import { apiEndpoints } from "core/api/apiEndpoints";
import { httpRequest } from "core/api/httpRequest";

// get quiz questionare
const getQuizQuestionare = () => {
  return httpRequest(apiEndpoints.quizQuestions, "get");
};

// submit quiz response
const submitQuizResponse = (payload: any) => {
  return httpRequest(apiEndpoints.quizResponse, "post", payload);
};

// get submitted quiz response
const submittedQuizResponse = () => {
  return httpRequest(apiEndpoints.submittedQuizResponse, "get");
};

// quiz result api
const getQuizResults = () => {
  return httpRequest(apiEndpoints.quizResults, "get");
};

export {
  getQuizQuestionare,
  submitQuizResponse,
  submittedQuizResponse,
  getQuizResults,
};
